import React from "react";

export default function RangeCell({ classes, freq, hand, onMouseEnter, onMouseLeave }) {
	return (
		<div className={classes} style={{ background: `rgba(120, 200, 255, ${freq})` }} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
			{`${hand} \n`}
		</div>
	);
}
